import React from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import { SimpleMultiSelect, SimpleSelect } from 'components/molecules';

const StatisticsSelectWrapper = props => {
  const { multiple } = props;

  return multiple ? (
    <SimpleMultiSelect {...props} />
  ) : (
    <SimpleSelect {...props} />
  );
};

StatisticsSelectWrapper.propTypes = {
  ...Select.propTypes,
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Placeholder
   */
  placeholder: PropTypes.string,
  /**
   * Text to show before the selected value on input
   */
  startText: PropTypes.string,
  /**
   * Item source data as shaped value | description
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,

  multiple: PropTypes.bool,
};

export default StatisticsSelectWrapper;
